module.exports = __webpack_public_path__ + "static/media/431178761_1122051598812745_6720034892722028455_n.f09e69b1.jpg";